import { Field, useFormikContext } from "formik";
import { useIntl } from "react-intl";
import * as Yup from "yup";

const validSchema = Yup.object({
  firstName: Yup.string(),
  lastName: Yup.string(),
  addressLine: Yup.string(),
  state: Yup.string(),
  zipCode: Yup.string(),
  country: Yup.string(),
  city: Yup.string(),
});

type ValidSchema = Yup.InferType<typeof validSchema>

export default function MarketPlace() {
  const intl = useIntl();
  const { errors, touched } = useFormikContext<ValidSchema>();

  return (
    <div className="pb-5" data-wizard-type="step-content" data-wizard-state="current">
      <h4 className="mb-10 font-weight-bold text-dark">{intl.formatMessage({ id: 'CHECKOUT.ADDRESS.INFO' })}</h4>

      <div className="row">
        <div className="col-xl-6">
          <div className="form-group">
            <label className='required form-label'>{intl.formatMessage({ id: 'CHECKOUT.ADDRESS.FIRST_NAME' })}</label>
            <div className='fv-row mb-4 form-floating'>
              <Field
                type='text'
                className='form-control'
                name='firstName'
                placeholder=''
              />
              <label>{intl.formatMessage({ id: 'CHECKOUT.ADDRESS.FIRST_NAME' })}</label>
            </div>
            <div className='fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback mb-4'>
              {errors.firstName && touched.firstName && (
                <div className='fv-help-block'>
                  {errors.firstName}
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="col-xl-6">
          <div className="form-group">
            <label className='required form-label'>{intl.formatMessage({ id: 'CHECKOUT.ADDRESS.LAST_NAME' })}</label>
            <div className='fv-row mb-4 form-floating'>
              <Field
                type='text'
                className='form-control'
                name='lastName'
                placeholder=''
              />
              <label>{intl.formatMessage({ id: 'CHECKOUT.ADDRESS.LAST_NAME' })}</label>
            </div>
            <div className='fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback mb-4'>
              {errors.lastName && touched.lastName && (
                <div className='fv-help-block'>
                  {errors.lastName}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="form-group fv-plugins-icon-container">
        <label className='required form-label'>{intl.formatMessage({ id: 'CHECKOUT.ADDRESS.ADDRESS_LINE' })}</label>
        <div className='fv-row mb-4 form-floating'>
          <Field
            type='text'
            className='form-control'
            name='addressLine'
            placeholder=''
          />
          <label>{intl.formatMessage({ id: 'CHECKOUT.ADDRESS.ADDRESS_LINE' })}</label>
        </div>
        <div className='fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback mb-4'>
          {errors.addressLine && touched.addressLine && (
            <div className='fv-help-block'>
              {errors?.addressLine}
            </div>
          )}
        </div>
      </div>

      <div className="row">
        <div className="col-xl-6">
          <div className="form-group">
            <label className='required form-label'>{intl.formatMessage({ id: 'CHECKOUT.ADDRESS.STATE' })}</label>
            <div className='fv-row mb-4 form-floating'>
              <Field
                type='text'
                className='form-control'
                name='state'
                placeholder=''
              />
              <label>{intl.formatMessage({ id: 'CHECKOUT.ADDRESS.STATE' })}</label>
            </div>
            <div className='fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback mb-4'>
              {errors.state && touched.state && (
                <div className='fv-help-block'>
                  {errors.state}
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="col-xl-6">
          <div className="form-group">
            <label className='required form-label'>{intl.formatMessage({ id: 'CHECKOUT.ADDRESS.ZIP_CODE' })}</label>
            <div className='fv-row mb-4 form-floating'>
              <Field
                type='text'
                className='form-control'
                name='zipCode'
                placeholder=''
              />
              <label>{intl.formatMessage({ id: 'CHECKOUT.ADDRESS.ZIP_CODE' })}</label>
            </div>
            <div className='fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback mb-4'>
              {errors.zipCode && touched.zipCode && (
                <div className='fv-help-block'>
                  {errors.zipCode}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-xl-6">
          <div className="form-group">
            <label className='required form-label'>{intl.formatMessage({ id: 'CHECKOUT.ADDRESS.CITY' })}</label>
            <div className='fv-row mb-4 form-floating'>
              <Field
                type='text'
                className='form-control'
                name='country'
                placeholder=''
              />
              <label>{intl.formatMessage({ id: 'CHECKOUT.ADDRESS.CITY' })}</label>
            </div>
            <div className='fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback mb-4'>
              {errors.country && touched.country && (
                <div className='fv-help-block'>
                  {errors.country}
                </div>
              )}
            </div>
          </div>
        </div>


        <div className="col-xl-6">
          <div className="form-group">
            <label className='required form-label'>{intl.formatMessage({ id: 'CHECKOUT.ADDRESS.COUNTRY' })}</label>
            <div className='fv-row mb-4 form-floating'>
              <Field
                type='text'
                className='form-control'
                name='city'
                placeholder=''
              />
              <label>{intl.formatMessage({ id: 'CHECKOUT.ADDRESS.COUNTRY' })}</label>
            </div>
            <div className='fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback mb-4'>
              {errors.city && touched.city && (
                <div className='fv-help-block'>
                  {errors.city}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
